import {PaletteColor} from "@mui/material";
import {ptBR} from '@mui/material/locale';
import {createTheme} from "@mui/material/styles"
import '@mui/x-date-pickers/themeAugmentation'
import {PickersTextFieldProps} from "@mui/x-date-pickers";


declare module '@mui/material/styles' {
	interface PaletteOverrides {
		primary: true,
		secondary: true,
		info: true,
		success: true
	}

	interface Palette {
		primary: PaletteColor;
		secondary: PaletteColor;
		info: PaletteColor;
	}

	interface ColorPalettePropOverrides {
		primary: true,
		secondary: true,
		info: true,
		success: true
	}

}

declare module '@mui/material/TableCell' {
	interface TableCellPropsVariantOverrides {
	}
}

declare module '@mui/material/TextField' {
	interface TextFieldPropsColorOverrides {
		inherit: true
	}
}

export const defPrimaryMaterial = () => {

	const primaryDark = {
		main: '#9b87f5',
		light: '#c4b5fd',
		dark: '#6d28d9',
		contrastText: '#ffffff',
	}
	const primaryLight = {
		main: '#7c3aed',
		light: '#ddd6fe',
		dark: '#5b21b6',
		contrastText: '#ffffff',
	}

	const info = {
		main: '#0ea5e9',
		light: '#bae6fd',
		dark: '#0369a1',
		contrastText: '#ffffff',
	}

	const secondary = {
		main: '#14b8a6',
		light: '#99f6e4',
		dark: '#0f766e',
		contrastText: '#ffffff',
	}

	const secondaryLight = {
		main: '#0d9488',
		light: '#99f6e4',
		dark: '#115e59',
		contrastText: '#ffffff',
	}

	const pickerTextfieldProps = {
		size: 'small',
		variant: 'filled',
		slotProps: {
			input: {
				sx: {
					borderRadius: 0,
				}
			},
			root: {
				sx: {
					borderRadius: 0
				}
			}
		}
	} as Partial<PickersTextFieldProps>


	return createTheme(
		{
			colorSchemes: {
				dark: { // Definindo a paleta para o modo escuro
					palette: {
						primary: primaryDark,
						secondary: secondary,
						info: info,
					},
				},
				light: { // Definindo a paleta para o modo claro
					palette: {
						primary: primaryLight,
						secondary: secondaryLight,
						info: info,
						success: {
							main: '#13ce1b',
						},
						error: {
							main: '#ff3e3e',
						},
						background: {
							paper: '#faf9fc',
							default: '#f3f1f7',
						}

					},
				},
			},
			shape: {
				borderRadius: 0,
			},
			components: {
				MuiDateTimeField: {
					defaultProps: {
						fullWidth: true,
						variant: 'filled',
						slotProps: {
							textField: {...pickerTextfieldProps},
						}
					}
				},
				MuiDateField: {
					defaultProps: {
						fullWidth: true,
						variant: 'filled',
						slotProps: {
							textField: {...pickerTextfieldProps},
						}
					}
				},
				MuiDatePicker: {
					defaultProps: {
						slotProps: {
							actionBar: {actions: ['clear', 'today']},
							textField: {...pickerTextfieldProps},
						}
					}
				},
				MuiIconButton: {
					styleOverrides: {
						root: {
							borderRadius: 0,
						},
					}
				},
				MuiButton: {
					defaultProps: {
						variant: 'outlined'
					}
				},
				MuiTextField: {
					defaultProps: {
						fullWidth: true,
						variant: 'filled',
						size: 'small',
						sx: {
							minWidth: 200
						}
					}
				},
				MuiFilledInput: {
					styleOverrides: {
						root: {
							borderRadius: 0
						},
					},
					defaultProps: {
						size: 'small',
						sx: {
							minWidth: 200
						}
					}
				},
				MuiOutlinedInput: {
					styleOverrides: {
						root: {
							borderRadius: 1,
						},
					},
					defaultProps: {
						size: 'small',
						sx: {
							minWidth: 200
						}

					}
				},
				MuiTab: {
					defaultProps: {
						iconPosition: 'end',
					},
					styleOverrides: {
						root: ({theme}) => ({
							textTransform: 'none',
							minHeight: 48,
							padding: '12px 16px',
							'&.Mui-selected': {
								fontWeight: theme.typography.fontWeightBold,
							},
						}),
					}
				},
				MuiChip: {
					styleOverrides: {
						root: {
							borderRadius: 3,
						},
						label: {
							whiteSpace: 'nowrap',
							maxWidth: '26ch',
							textOverflow: 'ellipsis',
							overflow: 'hidden'
						}
					}
				},
				MuiTable: {
					defaultProps: {
						size: 'small',
						stickyHeader: true,
					}
				},
				MuiTableHead: {
					defaultProps: {
						sx: {
							'& .MuiTableCell-root': {
								fontWeight: 'bold',
							}
						}
					}
				},
				MuiTableCell: {
					defaultProps: {
						sx: {
							whiteSpace: 'nowrap',
							maxWidth: '18ch',
							textOverflow: 'ellipsis',
							overflow: 'hidden'
						}
					}
				},
				MuiTooltip: {
					defaultProps: {
						enterDelay: 750,
						leaveDelay: 350,
						enterNextDelay: 150,
						arrow: true,
					}
				},
			},

			typography: {
				fontFamily: [
					'Inter',
					'sans-serif',
				].join(','),
			},

		}
		, ptBR);
}